import { GetItemAsync } from "./GetItemAsync"

export const getAsync: GetItemAsync = async (key) => {
  return localStorage.getItem(key) ?? undefined
}
